import { CHARITABLE_ENTITY_TYPES } from '@/modules/entities/entities.constants';
import { EntityType } from '@/modules/entities/types/EntityType';

/** Entity types that cannot receive a gift or a contribution. */
export const NON_GIFT_RECIPIENT_ENTITY_TYPES: Readonly<EntityType[]> = [
  ...CHARITABLE_ENTITY_TYPES,
  'insurance-account',
];
